import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Navigate } from '@ngxs/router-plugin';
import { ActiveDirectoryUserModel, AuthenticateUserCommand,  PastelCustomerDetailModel, PastelCustomerModel, PreRegisterResultModel, UserModel, UsersClient } from '@core/services/api.service';
import { LoadCustomerInfoAction, LoadCustomerInfoFailAction, LoadCustomerInfoSuccessAction, LoadPastelCustomerByAccountAction, LoadPastelCustomerByAccountFailAction, LoadPastelCustomerByAccountSuccessAction, RegisterAction, RegisterFailAction, RegisterSuccessAction, RequestOtpAction, RequestOtpFailAction, RequestOtpSuccessAction } from './register.actions';
import { catchError, tap } from 'rxjs/operators';
import { OpenToastrAction } from '@ngxs-store/ui-store/ui.actions';
import { SnackbarType } from '@core/models';
import { ToastrService } from 'ngx-toastr';
import { LoginAction } from '@ngxs-store/auth-store/auth.actions';
import { ToastrType } from '@core/models/ui/toastr-config';

export class RegisterStateModel {
    public isLoading: boolean;
    public signalRHandlersRegistered: boolean;
    public pastelCustomerDetail: PastelCustomerDetailModel;
    public customerInfo: PastelCustomerModel;
    public preRegisterResultModel: PreRegisterResultModel;
    public errMessage: string;
    public account: UserModel;
  }

@State<RegisterStateModel>({
    name: 'register',
    defaults: {
        isLoading: false,
        signalRHandlersRegistered: false,
        pastelCustomerDetail: null,
        customerInfo:null,
        preRegisterResultModel: null,
        errMessage: '',
        account: null
      }
})
@Injectable()
export class RegisterState {
    constructor(
        private registerService: UsersClient,
        private toaster: ToastrService
    ) { }

    @Selector()
    static isLoading(state: RegisterStateModel) {
        return state.isLoading;
    }

    @Selector()
    static getPastelCustomerDetail(state: RegisterStateModel) {
        return state.pastelCustomerDetail;
    }

    @Selector()
    static getPreRegisterResult(state: RegisterStateModel) {
        return state.preRegisterResultModel;
    }    

    @Selector()
    static getCustomerInfo(state: RegisterStateModel) {
        return state.customerInfo;
    }    

    @Selector()
    static getError(state: RegisterStateModel) {
        return state.errMessage;
    }   

    @Selector()
    static getAccount(state: RegisterStateModel) {

      
        return state.account;
    }      
   
    //Get Customer Info
    @Action(LoadCustomerInfoAction)
    loadCustomerInfoAction({ dispatch, patchState }: StateContext<RegisterStateModel>, action: LoadCustomerInfoAction) {


      patchState({ isLoading: true });
  
      return this.registerService.getCustomerDetails().pipe(
        tap((result) => dispatch(new LoadCustomerInfoSuccessAction({ customerInfo: result }))),
        catchError((err) => dispatch(new LoadCustomerInfoFailAction(err)))
      );
    }
  
    @Action(LoadCustomerInfoSuccessAction)
    loadCustomerInfoSuccessAction(ctx: StateContext<RegisterStateModel>, action: LoadCustomerInfoSuccessAction) {
      ctx.patchState({
        isLoading: false,
        customerInfo: action.payload.customerInfo
      });


  
    }
  
    @Action(LoadCustomerInfoFailAction)
    loadCustomerInfoFailAction(ctx: StateContext<RegisterStateModel>, action: LoadCustomerInfoFailAction) {
         ctx.patchState({        
        isLoading: false,
        errMessage: action.payload.response
        
      });
    }

    //Load Pastel Customer By Account (OTP)

    @Action(LoadPastelCustomerByAccountAction)
    loadPastelCustomerByAccountAction({ dispatch, patchState }: StateContext<RegisterStateModel>, action: LoadPastelCustomerByAccountAction) {


      patchState({ isLoading: true });
  
      return this.registerService.getUserOtpDetails(action.payload.loadPastelCustomerByAccountQuery).pipe(
        tap((result) => dispatch(new LoadPastelCustomerByAccountSuccessAction({ pastelCustomerDetail: result }))),
        catchError((err) => dispatch(new LoadPastelCustomerByAccountFailAction(err)))
      );
    }
  
    @Action(LoadPastelCustomerByAccountSuccessAction)
    loadPastelCustomerByAccountSuccessAction(ctx: StateContext<RegisterStateModel>, action: LoadPastelCustomerByAccountSuccessAction) {
      ctx.patchState({
        isLoading: false,
        pastelCustomerDetail: action.payload.pastelCustomerDetail
      });


  
    }
  
    @Action(LoadPastelCustomerByAccountFailAction)
    loadPastelCustomerByAccountFailAction(ctx: StateContext<RegisterStateModel>, action: LoadPastelCustomerByAccountFailAction) {
         ctx.patchState({        
        isLoading: false,
        errMessage: action.payload.response
        
      });
    }
    
    // Request OTP

    @Action(RequestOtpAction)
    requestOtpAction({ dispatch, patchState }: StateContext<RegisterStateModel>, action: RequestOtpAction) {
      patchState({ isLoading: true });
  
      return this.registerService.preRegisterAccount(action.payload.preRegisterUserCommand).pipe(
        tap((result) => dispatch(new RequestOtpSuccessAction({ preRegisterResultModel: result }))),
        catchError((err) => dispatch(new RequestOtpFailAction(err)))
      );
    }
  
    @Action(RequestOtpSuccessAction)
    requestOtpSuccessAction(ctx: StateContext<RegisterStateModel>, action: RequestOtpSuccessAction) {
      ctx.patchState({
        isLoading: false,
        preRegisterResultModel: action.payload.preRegisterResultModel
      });
      ctx.dispatch(new OpenToastrAction({ message: 'OTP SENT', type: ToastrType.success, title:'OTP Sent' }));
     // this.toaster.success("Success", "OTP SENT", { timeOut: 3000 });
    }
  
    @Action(RequestOtpFailAction)
    requestOtpFailAction(ctx: StateContext<RegisterStateModel>, action: RequestOtpFailAction) {
      ctx.patchState({
        
        isLoading: false,
        errMessage: action.payload.response
      });
    //  this.toaster.error(action.payload.response, "OTP Failed", { timeOut: 3000 });
      ctx.dispatch(new OpenToastrAction({ message: 'OTP Failed', type: ToastrType.error, title:'OTP Fail' }));
    }
    
    

// Register
    @Action(RegisterAction)
    registerAction({ dispatch, patchState }: StateContext<RegisterStateModel>, action: RegisterAction) {
      patchState({ isLoading: true });
  
      return this.registerService.registerExternalUser(action.payload.registerExternalUserCommand).pipe(
        tap((result) => dispatch(new RegisterSuccessAction({ account: result, registerExternalUserCommand: action.payload.registerExternalUserCommand }))),
        catchError((err) => dispatch(new RegisterFailAction(err)))
      );
    }
  
    @Action(RegisterSuccessAction)
    registerSuccessAction(ctx: StateContext<RegisterStateModel>, action: RegisterSuccessAction) {
      ctx.patchState({
        isLoading: false,
        account: action.payload.account
      });

      const authCommand = new AuthenticateUserCommand({ username: action.payload.registerExternalUserCommand.email, password: action.payload.registerExternalUserCommand.password });
      ctx.dispatch(new LoginAction({authenticateUserCommand: authCommand, redirectUrl: '/featured'  }));  
      
      ctx.dispatch(new OpenToastrAction({ message: 'Please login", "Registration Complete', type: ToastrType.success, title:'Registration Complete' }));    
    //  this.toaster.success("Please login", "Registration Complete", { timeOut: 3000 });
    }
  
    @Action(RegisterFailAction)
    registerFailAction(ctx: StateContext<RegisterStateModel>, action: RegisterFailAction) {
      ctx.patchState({
        
        isLoading: false,
        errMessage: action.payload.response
      });

     // this.toaster.error(action.payload.response, "Registration Error", { timeOut: 3000 });
      ctx.dispatch(new OpenToastrAction({ message: action.payload.response, type: ToastrType.error, title:'Registration Error' }));  
    }    
    
    
}
